<app-modal [open]="active" [name]="'bid'" (close)="closeDialog()">
  <div modal-header>Submit Quote?</div>
  <div modal-body>
    <div>
      By clicking “Submit”, you will submit your quote for review. <br /><br />
      Do you wish to continue?
    </div>
    <requirements-acknowledgement
      #reqAck
      [projectRequirements]="data?.specialQuoteRequirements"
      [siteRequirements]="data?.sites?.[0]?.site?.specialSiteCondition"
      [showSite]="true">
    </requirements-acknowledgement>
    <div class="bid-dialog__summary">
      <div class="bid-dialog__summary-item">
        <p class="bid-dialog__summary-label">Project</p>
        <p class="bid-dialog__summary-value">
          {{ "Project ID: " + (data?.projectOrderId ?? "") }}
        </p>
      </div>
    </div>
  </div>
  <button
    modal-footer
    type="button"
    class="btn btn--primary"
    data-testid="bid-confirm"
    (click)="submit()"
    [disabled]="isSubmitting || (reqAck?.requiresAcknowledgement && !reqAck?.acknowledged)"
  >
    Submit
  </button>
  <button
    modal-footer
    type="button"
    class="btn btn--secondary"
    data-testid="bid-cancel"
    (click)="closeDialog()"
  >
    Cancel
  </button>
</app-modal>
